var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPockericon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_15_10",
    "data-name": "Component 15 \\u2013 10",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.597,
    height: 54.773,
    viewBox: "0 0 55.597 54.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M433.289,41.083,420.009,27.8a14.893,14.893,0,0,1,2.084,2.612,14.794,14.794,0,0,1,3.383,7.739,15.053,15.053,0,0,1-.007,3.855,14.734,14.734,0,0,1-2.982,7.121l-4.811,6.2-4.544,5.859-1.025,1.322a14.9,14.9,0,0,0,20.9-.123l.28-.28A14.887,14.887,0,0,0,433.289,41.083Z",
    transform: "translate(-382.04 -24.155)",
    fill: "#eee23e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M222.19,4.628l-.28-.28a14.887,14.887,0,0,0-21.03,0l-9.106,9.106-4.451,4.451a14.887,14.887,0,0,0,0,21.03l.279.279a14.9,14.9,0,0,0,21.03,0l2.763-2.763,5.243-5.243,5.551-5.551a14.735,14.735,0,0,0,3.852-6.691,15.032,15.032,0,0,0,.49-3.823A14.766,14.766,0,0,0,222.19,4.628Z",
    transform: "translate(-182.976)",
    fill: "#eee23e"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 6.376,
    cy: 6.376,
    r: 6.376,
    transform: "translate(20.798 42.021)",
    fill: "#eee23e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPockericon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/pocker.icon.757aa614d3fcd215d8eeb84b1fec68a9.svg";
export { ForwardRef as ReactComponent };